import React from 'react'
import './styles.scss'
import '../../styles/index.scss'

export default ({ children }) => (
  <div className='form-group check-error'>
    <div className='row'>
      <div className='radio-inline-group'>
        {children}
      </div>
    </div>
  </div>
)
